import { Component } from 'nospa';

import mediaBreakpoints from '@/helpers/mediaBreakpoints';

const ACTIVE_CLASSNAME = '_children-active';

export default class HeaderNavItem extends Component {
  onInit() {
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);

    this.childrenRef = this.$getRef('children');

    this.setEvents();
    this.onBreakpointChange();
    mediaBreakpoints.subscribe(this.onBreakpointChange);
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';

    if (this.childrenRef) {
      this.childrenRef.el[action]('mouseenter', this.onMouseEnter);
      this.childrenRef.el[action]('mouseleave', this.onMouseLeave);
    }

    this.$el[action]('mouseenter', this.onMouseEnter);
    this.$el[action]('mouseleave', this.onMouseLeave);
  }

  onMouseEnter() {
    if (this.isMobileMode) return;
    clearTimeout(this.leaveTimeout);
    this.$el.classList.add(ACTIVE_CLASSNAME);
  }

  onMouseLeave() {
    if (this.isMobileMode) return;
    clearTimeout(this.leaveTimeout);
    this.leaveTimeout = setTimeout(() => {
      this.$el.classList.remove(ACTIVE_CLASSNAME);
    }, 500);
  }

  onBreakpointChange() {
    const isMobileMode = !mediaBreakpoints.isUp(mediaBreakpoints.breakpoints.XL);
    if (isMobileMode) {
      clearTimeout(this.leaveTimeout);
      this.$el.classList.remove(ACTIVE_CLASSNAME);
    }
    this.isMobileMode = isMobileMode;
  }

  onDestroy() {
    this.setEvents(false);
    clearTimeout(this.leaveTimeout);
    this.$el.classList.remove(ACTIVE_CLASSNAME);
    mediaBreakpoints.unsubscribe(this.onBreakpointChange);
  }
}
